import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import db from '@services/firebase-service';

const useStreamTimeStatus = (streamId) => {
  const [streamInfo, setStreamInfo] = useState({
    hasReachedMaxTimeLimit: false,
    monthlyDurationInMins: 0
  });

  useEffect(() => {
    const unsubscribe = onSnapshot(doc(db, 'streams', streamId), (document) => {
      if (document.exists && document.data()) {
        const { hasReachedMaxTimeLimit = false, monthlyDurationInMins = 0 } = document.data();

        setStreamInfo({
          hasReachedMaxTimeLimit,
          monthlyDurationInMins
        });
      }
    });

    return () => unsubscribe();
  }, [streamId]);

  return streamInfo;
};

export default useStreamTimeStatus;
